<template>
  <div :style="`background-color:${bgColor}; color: ${textColor}`">
    <div
      v-if="aboutusLink || privacyPolicyLink || termsLink"
      class="
        flex
        md:flex-row
        md:justify-between
        flex-col
        justify-center
        items-center
        py-6
        border-b border-gray-200
      "
    >
      <div class="md:flex flex-1 flex-wrap justify-center text-center">
        <div class="md:mx-5 md:my-1 my-4" v-if="aboutusLink">
          <a :href="aboutusLink" target="_blank">About Us</a>
        </div>
        <div class="md:mx-5 md:my-1 my-4" v-if="privacyPolicyLink">
          <a :href="privacyPolicyLink" target="_blank">Privacy Policy</a>
        </div>
        <div class="md:mx-5 md:my-1 my-4" v-if="termsLink">
          <a :href="termsLink" target="_blank">Term &amp; Condition</a>
        </div>
      </div>
    </div>
    <div class="flex justify-center text-xs py-6" v-if="copyrights">
      <div class="leading-6">© {{ copyrights }}</div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Footer',
  props: {
    copyrights: {},
    aboutusLink: {},
    privacyPolicyLink: {},
    termsLink: {},
    bgColor: {},
    textColor: {},
  },
};
</script>
